import { authenticationEmitter, AuthenticationEvents } from 'helpers/auth';

import { CompanySupposedBeneficiary } from '../../../../../../__generated__/GQL';

const LOCALSTORAGE_KEY = 'onboarding.deletedSupposedBeneficiaries';

export const getDeletedSupposedBeneficiaries = (): Set<string> => {
  const item = window.localStorage.getItem(LOCALSTORAGE_KEY);

  if (!item) {
    return new Set<string>();
  }

  try {
    const deletedSupposedBeneficiariesList = JSON.parse(item) as string[];
    return new Set(deletedSupposedBeneficiariesList);
  } catch {
    window.localStorage.removeItem(LOCALSTORAGE_KEY);
    return new Set<string>();
  }
};

export const saveDeletedSupposedBeneficiaries = (
  deletedSupposedBeneficiariesList: Set<string>,
): void => {
  window.localStorage.setItem(
    LOCALSTORAGE_KEY,
    JSON.stringify(Array.from(deletedSupposedBeneficiariesList)),
  );
};

authenticationEmitter.addListener(AuthenticationEvents.OnLogout, () => {
  window.localStorage.removeItem(LOCALSTORAGE_KEY);
});

export const getActiveSupposedBeneficiaries = (
  supposedBeneficiaries: CompanySupposedBeneficiary[],
) => {
  const deletedSupposedBeneficiaries = getDeletedSupposedBeneficiaries();
  return supposedBeneficiaries.filter(({ supposedBeneficiaryId }) => {
    return !deletedSupposedBeneficiaries.has(supposedBeneficiaryId);
  });
};
